export function initFileInput(inputId) {
    const input = document.getElementById(inputId);

    if (!input) {
        return;
    }

    const container = input.closest('.form__file');

    if (!container) {
        return;
    }

    const fileName = container.querySelector('.form__file-name');

    if (!fileName) {
        return;
    }

    input.addEventListener('change', () => {
        fileName.textContent = input.files.length
            ? input.files[0].name
            : 'Nie wybrano pliku';
    });
}
